'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CALL_API = undefined;
var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];
    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }
  return target;
};
var _slicedToArray = function () {
  function sliceIterator(arr, i) {
    var _arr = [];
    var _n = true;
    var _d = false;
    var _e = undefined;
    try {
      for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) {
        _arr.push(_s.value);
        if (i && _arr.length === i) break;
      }
    } catch (err) {
      _d = true;
      _e = err;
    } finally {
      try {
        if (!_n && _i["return"]) _i["return"]();
      } finally {
        if (_d) throw _e;
      }
    }
    return _arr;
  }
  return function (arr, i) {
    if (Array.isArray(arr)) {
      return arr;
    } else if (Symbol.iterator in Object(arr)) {
      return sliceIterator(arr, i);
    } else {
      throw new TypeError("Invalid attempt to destructure non-iterable instance");
    }
  };
}();
var _jsonapiNormalizer = require('jsonapi-normalizer');
var _jsonapiNormalizer2 = _interopRequireDefault(_jsonapiNormalizer);
var _humps = require('humps');
var _urls = require('../constants/urls');
var _urls2 = _interopRequireDefault(_urls);
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
function _toConsumableArray(arr) {
  if (Array.isArray(arr)) {
    for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) {
      arr2[i] = arr[i];
    }
    return arr2;
  } else {
    return Array.from(arr);
  }
}
var CALL_API = exports.CALL_API = 'Call API';
var fullUrlRegex = /^http[s]?:\/\//i;
var getFullUrl = function getFullUrl(endpoint) {
  var apiRoot = _urls2.default.getApiRoot();
  return fullUrlRegex.test(endpoint) ? endpoint : apiRoot + endpoint;
};
var callApi = function callApi(endpoint, passActionWith, types) {
  var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
  var fetchAllPages = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : false;
  var pageOrder = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : [];
  var fullUrl = getFullUrl(endpoint);
  var _types = _slicedToArray(types, 3),
    requestType = _types[0],
    successType = _types[1],
    failureType = _types[2];
  passActionWith({
    type: requestType
  });
  return fetch(fullUrl, options).then(function (serverResponse) {
    return serverResponse.json().then(function (json) {
      if (!serverResponse.ok) {
        console.error('API:', serverResponse);
        return Promise.reject(_extends({}, json, {
          status: serverResponse.status
        }));
      }
      var nextPage = json && json.links && json.links.next;
      var selfPage = json && json.links && json.links.self;
      if (fetchAllPages && !!nextPage) callApi(nextPage, passActionWith, types, options, fetchAllPages, [].concat(_toConsumableArray(pageOrder), [selfPage]));
      return json && json.data ? _extends({
        type: !!json.data.length ? json.data[0].type : null
      }, (0, _jsonapiNormalizer2.default)((0, _humps.camelizeKeys)(json)), {
        links: json.links,
        pageOrder: fetchAllPages && !nextPage ? [].concat(_toConsumableArray(pageOrder), [selfPage]) : undefined
      }) : json;
    });
  }).then(function (response) {
    return passActionWith({
      response: response,
      type: successType
    });
  }, function (error) {
    return passActionWith({
      type: failureType,
      error: error.message || 'Something bad happened',
      status: error.status
    });
  });
};
exports.default = function (store) {
  return function (next) {
    return function (action) {
      var callAPI = action[CALL_API];
      if (typeof callAPI === 'undefined') return next(action);
      var types = callAPI.types,
        options = callAPI.options,
        fetchAllPages = callAPI.fetchAllPages;
      var endpoint = callAPI.endpoint;
      if (typeof endpoint === 'function') endpoint = endpoint(store.getState());
      if (typeof endpoint !== 'string') throw new Error('Specify a string endpoint URL.');
      if (!Array.isArray(types) || types.length !== 3) throw new Error('Expected an array of three action types.');
      if (!types.every(function (type) {
        return typeof type === 'string';
      })) throw new Error('Expected action types to be strings.');
      var passActionWith = function passActionWith(data) {
        var finalAction = _extends({}, action, data);
        delete finalAction[CALL_API];
        return next(finalAction);
      };
      return callApi(endpoint, passActionWith, types, options, fetchAllPages);
    };
  };
};